import api from '@pray/shared/utils/api';

export type GetContractSpendTotalParams = {
  artistId: string;
};

export type GetContractSpendTotalResponse = {
  artist_id: string;
  /** Sum of daily_budget_cents across active MarketingCampaigns. */
  daily_budget_cents_total: number;
  active_contract_count: number;
};

export const getContractSpendTotal = async ({
  artistId,
}: GetContractSpendTotalParams): Promise<GetContractSpendTotalResponse> => {
  const url = '/web/studio/superfunnel/contracts/spend-total';
  const response = await api.executeGetRequest(url, { artist_id: artistId });
  return (response.data as { data: GetContractSpendTotalResponse }).data;
};
